import { Spinner } from 'reactstrap';

const LoaderBlur = (props: any) => {
    return (
        <div className="loader-blur" style={{
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            background: 'rgba(255, 255, 255, 0.7)',
            zIndex: 10,
            backdropFilter: 'blur(1px)'
        }}>
            <Spinner color="primary" />
        </div>
    );
};

export default LoaderBlur;